// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Component-specific styles */

/* Header Component */
.header {
    background-color: #2563eb;
    color: white;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  
  .header .container {
    padding: 1rem;
  }
  
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 1rem;
  }
  
  .header-logo {
    font-size: 1.5rem;
    font-weight: 700;
    color: white;
    text-decoration: none;
  }
  
  .header-logo:hover {
    color: #bfdbfe;
  }
  
  .header-nav {
    display: flex;
    align-items: center;
    gap: 1.5rem;
    flex-wrap: wrap;
  }
  
  .header-nav a {
    color: white;
    text-decoration: none;
    transition: color 0.2s ease-in-out;
  }
  
  .header-nav a:hover {
    color: #bfdbfe;
  }
  
  .header-nav button {
    background-color: #1d4ed8;
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 0.25rem;
    cursor: pointer;
    transition: background-color 0.2s ease-in-out;
  }
  
  .header-nav button:hover {
    background-color: #1e40af;
  }
  
  .header-welcome {
    color: #bfdbfe;
    font-size: 0.875rem;
  }
  
  /* Footer Component */
  .footer {
    background-color: #1f2937;
    color: white;
    padding: 2rem 0;
    margin-top: auto;
  }
  
  .footer .container {
    padding: 0 1rem;
  }
  
  .footer-content {
    display: grid;
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .footer-section h3,
  .footer-section h4 {
    font-size: 1.125rem;
    font-weight: 600;
    margin-bottom: 1rem;
    color: white;
  }
  
  .footer-section p {
    color: #9ca3af;
    line-height: 1.6;
  }
  
  .footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .footer-links li {
    margin-bottom: 0.5rem;
  }
  
  .footer-links a {
    color: #9ca3af;
    text-decoration: none;
    transition: color 0.2s ease-in-out;
  }
  
  .footer-links a:hover {
    color: white;
  }
  
  .footer-social {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
  }
  
  .footer-social a {
    color: #9ca3af;
    text-decoration: none;
    transition: color 0.2s ease-in-out;
  }
  
  .footer-social a:hover {
    color: white;
  }
  
  .footer-bottom {
    border-top: 1px solid #374151;
    margin-top: 2rem;
    padding-top: 2rem;
    text-align: center;
    color: #9ca3af;
  }
  
  @media (min-width: 768px) {
    .footer-content {
      grid-template-columns: repeat(4, 1fr);
    }
    
    .footer-social {
      flex-wrap: nowrap;
    }
  }
  
  /* Error Message Component */
  .error-message {
    background-color: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 0.375rem;
    padding: 1rem;
    margin: 1rem 0;
    display: flex;
    align-items: flex-start;
  }
  
  .error-icon {
    height: 1.25rem;
    width: 1.25rem;
    color: #f87171;
    flex-shrink: 0;
  }
  
  .error-content {
    margin-left: 0.75rem;
  }
  
  .error-text {
    font-size: 0.875rem;
    color: #991b1b;
    margin: 0 0 0.5rem 0;
  }
  
  .error-retry {
    margin-top: 0.5rem;
    font-size: 0.875rem;
    color: #dc2626;
    background: none;
    border: none;
    text-decoration: underline;
    cursor: pointer;
    padding: 0;
  }
  
  .error-retry:hover {
    color: #ef4444;
  }
  
  /* Login Form Specific Styles */
  .login-page {
    min-height: 100vh;
    background-color: #f9fafb;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 3rem 1rem;
  }
  
  .login-header {
    text-align: center;
    margin: 0 auto;
    width: 100%;
    max-width: 28rem;
  }
  
  .login-title {
    margin-top: 1.5rem;
    font-size: 1.875rem;
    line-height: 2.25rem;
    font-weight: 700;
    color: #111827;
  }
  
  .login-subtitle {
    margin-top: 0.5rem;
    font-size: 0.875rem;
    color: #4b5563;
  }
  
  .login-subtitle a {
    font-weight: 500;
    color: #2563eb;
    text-decoration: none;
  }
  
  .login-subtitle a:hover {
    color: #3b82f6;
  }
  
  .login-form-wrapper {
    margin-top: 2rem;
    width: 100%;
    max-width: 28rem;
    margin-left: auto;
    margin-right: auto;
  }
  
  .login-form-container {
    background-color: white;
    padding: 2rem 1rem;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
    border-radius: 0.5rem;
  }
  
  @media (min-width: 640px) {
    .login-form-container {
      padding: 2rem 2.5rem;
    }
    
    .login-page {
      padding-left: 1.5rem;
      padding-right: 1.5rem;
    }
  }
  
  @media (min-width: 1024px) {
    .login-page {
      padding-left: 2rem;
      padding-right: 2rem;
    }
  }
  
  /* Form Elements */
  .form-group {
    margin-bottom: 1.5rem;
  }
  
  .form-label {
    display: block;
    font-size: 0.875rem;
    font-weight: 500;
    color: #374151;
    margin-bottom: 0.25rem;
  }
  
  .form-input {
    appearance: none;
    display: block;
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #d1d5db;
    border-radius: 0.375rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: #111827;
    background-color: white;
    transition: all 0.2s ease-in-out;
  }
  
  .form-input::placeholder {
    color: #9ca3af;
  }
  
  .form-input:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
  
  .form-submit {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.75rem 1rem;
    border: 1px solid transparent;
    border-radius: 0.375rem;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    font-size: 0.875rem;
    font-weight: 500;
    color: white;
    background-color: #2563eb;
    cursor: pointer;
    transition: background-color 0.2s ease-in-out;
  }
  
  .form-submit:hover:not(:disabled) {
    background-color: #1d4ed8;
  }
  
  .form-submit:focus {
    outline: none;
    box-shadow: 0 0 0 2px white, 0 0 0 4px rgba(59, 130, 246, 0.5);
  }
  
  .form-submit:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  /* Mobile responsive adjustments */
  @media (max-width: 640px) {
    .header-content {
      flex-direction: column;
      text-align: center;
    }
    
    .header-nav {
      flex-direction: column;
      gap: 0.5rem;
      width: 100%;
    }
    
    .footer-social {
      justify-content: center;
    }
    
    .login-page {
      padding: 1rem 0.5rem;
    }
    
    .login-title {
      font-size: 1.5rem;
      line-height: 2rem;
    }
  }`, "",{"version":3,"sources":["webpack://./src/styles/components.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B,qBAAqB;AACrB;IACI,yBAAyB;IACzB,YAAY;IACZ,mFAAmF;EACrF;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,qBAAqB;IACrB,kCAAkC;EACpC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;IACf,6CAA6C;EAC/C;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA,qBAAqB;EACrB;IACE,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,0BAA0B;IAC1B,SAAS;EACX;;EAEA;;IAEE,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,kCAAkC;EACpC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,kCAAkC;EACpC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE;MACE,qCAAqC;IACvC;;IAEA;MACE,iBAAiB;IACnB;EACF;;EAEA,4BAA4B;EAC5B;IACE,yBAAyB;IACzB,yBAAyB;IACzB,uBAAuB;IACvB,aAAa;IACb,cAAc;IACd,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA,+BAA+B;EAC/B;IACE,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,2EAA2E;IAC3E,qBAAqB;EACvB;;EAEA;IACE;MACE,oBAAoB;IACtB;;IAEA;MACE,oBAAoB;MACpB,qBAAqB;IACvB;EACF;;EAEA;IACE;MACE,kBAAkB;MAClB,mBAAmB;IACrB;EACF;;EAEA,kBAAkB;EAClB;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,cAAc;IACd,uBAAuB;IACvB,gCAAgC;EAClC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,6CAA6C;EAC/C;;EAEA;IACE,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,6BAA6B;IAC7B,uBAAuB;IACvB,2CAA2C;IAC3C,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,6CAA6C;EAC/C;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,8DAA8D;EAChE;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA,kCAAkC;EAClC;IACE;MACE,sBAAsB;MACtB,kBAAkB;IACpB;;IAEA;MACE,sBAAsB;MACtB,WAAW;MACX,WAAW;IACb;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,oBAAoB;IACtB;;IAEA;MACE,iBAAiB;MACjB,iBAAiB;IACnB;EACF","sourcesContent":["/* Component-specific styles */\n\n/* Header Component */\n.header {\n    background-color: #2563eb;\n    color: white;\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n  \n  .header .container {\n    padding: 1rem;\n  }\n  \n  .header-content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 1rem;\n  }\n  \n  .header-logo {\n    font-size: 1.5rem;\n    font-weight: 700;\n    color: white;\n    text-decoration: none;\n  }\n  \n  .header-logo:hover {\n    color: #bfdbfe;\n  }\n  \n  .header-nav {\n    display: flex;\n    align-items: center;\n    gap: 1.5rem;\n    flex-wrap: wrap;\n  }\n  \n  .header-nav a {\n    color: white;\n    text-decoration: none;\n    transition: color 0.2s ease-in-out;\n  }\n  \n  .header-nav a:hover {\n    color: #bfdbfe;\n  }\n  \n  .header-nav button {\n    background-color: #1d4ed8;\n    color: white;\n    border: none;\n    padding: 0.5rem 1rem;\n    border-radius: 0.25rem;\n    cursor: pointer;\n    transition: background-color 0.2s ease-in-out;\n  }\n  \n  .header-nav button:hover {\n    background-color: #1e40af;\n  }\n  \n  .header-welcome {\n    color: #bfdbfe;\n    font-size: 0.875rem;\n  }\n  \n  /* Footer Component */\n  .footer {\n    background-color: #1f2937;\n    color: white;\n    padding: 2rem 0;\n    margin-top: auto;\n  }\n  \n  .footer .container {\n    padding: 0 1rem;\n  }\n  \n  .footer-content {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 2rem;\n  }\n  \n  .footer-section h3,\n  .footer-section h4 {\n    font-size: 1.125rem;\n    font-weight: 600;\n    margin-bottom: 1rem;\n    color: white;\n  }\n  \n  .footer-section p {\n    color: #9ca3af;\n    line-height: 1.6;\n  }\n  \n  .footer-links {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n  }\n  \n  .footer-links li {\n    margin-bottom: 0.5rem;\n  }\n  \n  .footer-links a {\n    color: #9ca3af;\n    text-decoration: none;\n    transition: color 0.2s ease-in-out;\n  }\n  \n  .footer-links a:hover {\n    color: white;\n  }\n  \n  .footer-social {\n    display: flex;\n    gap: 1rem;\n    flex-wrap: wrap;\n  }\n  \n  .footer-social a {\n    color: #9ca3af;\n    text-decoration: none;\n    transition: color 0.2s ease-in-out;\n  }\n  \n  .footer-social a:hover {\n    color: white;\n  }\n  \n  .footer-bottom {\n    border-top: 1px solid #374151;\n    margin-top: 2rem;\n    padding-top: 2rem;\n    text-align: center;\n    color: #9ca3af;\n  }\n  \n  @media (min-width: 768px) {\n    .footer-content {\n      grid-template-columns: repeat(4, 1fr);\n    }\n    \n    .footer-social {\n      flex-wrap: nowrap;\n    }\n  }\n  \n  /* Error Message Component */\n  .error-message {\n    background-color: #fef2f2;\n    border: 1px solid #fecaca;\n    border-radius: 0.375rem;\n    padding: 1rem;\n    margin: 1rem 0;\n    display: flex;\n    align-items: flex-start;\n  }\n  \n  .error-icon {\n    height: 1.25rem;\n    width: 1.25rem;\n    color: #f87171;\n    flex-shrink: 0;\n  }\n  \n  .error-content {\n    margin-left: 0.75rem;\n  }\n  \n  .error-text {\n    font-size: 0.875rem;\n    color: #991b1b;\n    margin: 0 0 0.5rem 0;\n  }\n  \n  .error-retry {\n    margin-top: 0.5rem;\n    font-size: 0.875rem;\n    color: #dc2626;\n    background: none;\n    border: none;\n    text-decoration: underline;\n    cursor: pointer;\n    padding: 0;\n  }\n  \n  .error-retry:hover {\n    color: #ef4444;\n  }\n  \n  /* Login Form Specific Styles */\n  .login-page {\n    min-height: 100vh;\n    background-color: #f9fafb;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 3rem 1rem;\n  }\n  \n  .login-header {\n    text-align: center;\n    margin: 0 auto;\n    width: 100%;\n    max-width: 28rem;\n  }\n  \n  .login-title {\n    margin-top: 1.5rem;\n    font-size: 1.875rem;\n    line-height: 2.25rem;\n    font-weight: 700;\n    color: #111827;\n  }\n  \n  .login-subtitle {\n    margin-top: 0.5rem;\n    font-size: 0.875rem;\n    color: #4b5563;\n  }\n  \n  .login-subtitle a {\n    font-weight: 500;\n    color: #2563eb;\n    text-decoration: none;\n  }\n  \n  .login-subtitle a:hover {\n    color: #3b82f6;\n  }\n  \n  .login-form-wrapper {\n    margin-top: 2rem;\n    width: 100%;\n    max-width: 28rem;\n    margin-left: auto;\n    margin-right: auto;\n  }\n  \n  .login-form-container {\n    background-color: white;\n    padding: 2rem 1rem;\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n    border-radius: 0.5rem;\n  }\n  \n  @media (min-width: 640px) {\n    .login-form-container {\n      padding: 2rem 2.5rem;\n    }\n    \n    .login-page {\n      padding-left: 1.5rem;\n      padding-right: 1.5rem;\n    }\n  }\n  \n  @media (min-width: 1024px) {\n    .login-page {\n      padding-left: 2rem;\n      padding-right: 2rem;\n    }\n  }\n  \n  /* Form Elements */\n  .form-group {\n    margin-bottom: 1.5rem;\n  }\n  \n  .form-label {\n    display: block;\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: #374151;\n    margin-bottom: 0.25rem;\n  }\n  \n  .form-input {\n    appearance: none;\n    display: block;\n    width: 100%;\n    padding: 0.75rem;\n    border: 1px solid #d1d5db;\n    border-radius: 0.375rem;\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n    color: #111827;\n    background-color: white;\n    transition: all 0.2s ease-in-out;\n  }\n  \n  .form-input::placeholder {\n    color: #9ca3af;\n  }\n  \n  .form-input:focus {\n    outline: none;\n    border-color: #3b82f6;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n  }\n  \n  .form-submit {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0.75rem 1rem;\n    border: 1px solid transparent;\n    border-radius: 0.375rem;\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: white;\n    background-color: #2563eb;\n    cursor: pointer;\n    transition: background-color 0.2s ease-in-out;\n  }\n  \n  .form-submit:hover:not(:disabled) {\n    background-color: #1d4ed8;\n  }\n  \n  .form-submit:focus {\n    outline: none;\n    box-shadow: 0 0 0 2px white, 0 0 0 4px rgba(59, 130, 246, 0.5);\n  }\n  \n  .form-submit:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n  \n  /* Mobile responsive adjustments */\n  @media (max-width: 640px) {\n    .header-content {\n      flex-direction: column;\n      text-align: center;\n    }\n    \n    .header-nav {\n      flex-direction: column;\n      gap: 0.5rem;\n      width: 100%;\n    }\n    \n    .footer-social {\n      justify-content: center;\n    }\n    \n    .login-page {\n      padding: 1rem 0.5rem;\n    }\n    \n    .login-title {\n      font-size: 1.5rem;\n      line-height: 2rem;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
